"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackorderItem = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _ColoredBadge = require("./ColoredBadge");
var _jsxRuntime = require("react/jsx-runtime");
const LightTooltip = (0, _mui.styled)(_mui.Tooltip)(({
  theme
}) => ({
  fontSize: theme.typography.body1.fontSize
}));
const TooltipLine = (0, _mui.styled)(_mui.Box)(({
  theme
}) => ({
  margin: '4px 0',
  color: theme.palette.text.primary
}));
const BlockLink = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  marginBottom: theme.spacing(3),
  borderRadius: theme.spacing(2),
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.paper,
  boxShadow: _mui.SHADOW_LEVEL3
}));
const MerchContentWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  padding: theme.spacing(3, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4, 0)
  }
}));
const MerchHeader = (0, _mui.styled)('div')(({
  theme
}) => ({
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 'bold',
  color: theme.palette.text.primary,
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(1)
  }
}));
const MerchContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'inline-block',
  paddingRight: theme.spacing(3),
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 'normal',
  color: theme.palette.text.primary,
  [theme.breakpoints.up('md')]: {
    paddingRight: theme.spacing(6),
    fontSize: theme.typography.body1.fontSize
  }
}));
const BackorderItem = ({
  color,
  text,
  title,
  toolTip,
  ...htmlDivProps
}) => {
  const tooltipContent = (0, _react.useMemo)(() => toolTip?.split('<br/>').map(line => line !== '' && /*#__PURE__*/(0, _jsxRuntime.jsx)(TooltipLine, {
    children: line
  }, line)) ?? '', [toolTip]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(BlockLink, {
    ...htmlDivProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ColoredBadge.ColoredBadge, {
      itemTheme: color
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MerchContentWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LightTooltip, {
        enterTouchDelay: 50,
        leaveTouchDelay: 5000,
        title: tooltipContent,
        placement: "top-start",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MerchHeader, {
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MerchContent, {
            dangerouslySetInnerHTML: {
              __html: text
            }
          })]
        })
      })
    })]
  });
};
exports.BackorderItem = BackorderItem;